/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LibJoinersDriverBehaviourLightVehiclesDriver
 */
export interface LibJoinersDriverBehaviourLightVehiclesDriver {
    /**
     * 
     * @type {number}
     * @memberof LibJoinersDriverBehaviourLightVehiclesDriver
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LibJoinersDriverBehaviourLightVehiclesDriver
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LibJoinersDriverBehaviourLightVehiclesDriver
     */
    surname?: string;
}

export function LibJoinersDriverBehaviourLightVehiclesDriverFromJSON(json: any): LibJoinersDriverBehaviourLightVehiclesDriver {
    return LibJoinersDriverBehaviourLightVehiclesDriverFromJSONTyped(json, false);
}

export function LibJoinersDriverBehaviourLightVehiclesDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): LibJoinersDriverBehaviourLightVehiclesDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
    };
}

export function LibJoinersDriverBehaviourLightVehiclesDriverToJSON(value?: LibJoinersDriverBehaviourLightVehiclesDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'surname': value.surname,
    };
}


